module.exports = __webpack_public_path__ + "static/media/background.cdba8d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elimination-lobby/background.jpg
// module id = 328
// module chunks = 0